const getters = {
    getProducts: state => state.products,
    getProductId: (state) => (id) => {
        return state.products.find(product => product.id == id)
    },

    getAttributes: state => state.attributes

}

export default getters